import React from 'react';
import { reduxForm, Field } from 'redux-form';

import InputField from 'components/InputField';
import FormError from 'components/FormError';

let SearchSimoDevicesForm = ({ handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <Field component={InputField} name="serial_number" label="Device SN" />
    <Field component={InputField} name="user_profile" label="User Profile ID" />
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-default">Search Devices</button>
  </form>
);

SearchSimoDevicesForm = reduxForm({
  form: 'searchSimoDevices',
})(SearchSimoDevicesForm);

export default SearchSimoDevicesForm;
